export const parseTime = (time) => {
	const toReturn = new Intl.DateTimeFormat("default", {
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	}).format(new Date(time));

	return toReturn;
};
